/* ==========================================================================
   WATCHFACTS — Cart Drawer
   ========================================================================== */

(function () {
  'use strict';

  const drawer = document.getElementById('wf-cart-drawer');
  const overlay = document.getElementById('wf-overlay');
  const itemsContainer = document.getElementById('wf-cart-items');
  const subtotalEl = document.getElementById('wf-cart-subtotal');
  const countEls = document.querySelectorAll('.wf-header__cart-count');

  const Cart = {
    open() {
      if (!drawer) return;
      drawer.classList.add('wf-active');
      if (overlay) overlay.classList.add('wf-active');
      document.body.style.overflow = 'hidden';
    },

    close() {
      if (!drawer) return;
      drawer.classList.remove('wf-active');
      if (overlay) overlay.classList.remove('wf-active');
      document.body.style.overflow = '';
    },

    async get() {
      const res = await fetch('/cart.js');
      return res.json();
    },

    async add(variantId, quantity = 1) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!res.ok) throw new Error('No se pudo agregar al carrito');
      return res.json();
    },

    async update(updates) {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      return res.json();
    },

    async change(lineItem, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineItem, quantity }),
      });
      return res.json();
    },

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return `${amount.replace('.', ',')} €`;
    },

    async refresh() {
      const cart = await Cart.get();
      Cart.render(cart);
      Cart.updateCount(cart.item_count);
    },

    updateCount(count) {
      countEls.forEach((el) => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    render(cart) {
      if (!itemsContainer) return;

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = `
          <div class="wf-cart-drawer__empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <p class="wf-cart-drawer__empty-title">Tu carrito está vacío</p>
            <p class="wf-cart-drawer__empty-desc">Descubre nuestra colección de relojes de lujo</p>
            <a href="/collections/all" class="wf-btn" style="margin-top:16px"><span>Explorar colección</span></a>
          </div>`;
        if (subtotalEl) subtotalEl.textContent = Cart.formatMoney(0);
        return;
      }

      const itemsHTML = cart.items.map((item, index) => `
        <div class="wf-cart-item" data-line="${index + 1}">
          <div class="wf-cart-item__image">
            <a href="${item.url}">
              <img src="${item.image ? item.image.replace('http:', 'https:') : ''}" alt="${item.title}" loading="lazy" width="80" height="80">
            </a>
          </div>
          <div class="wf-cart-item__info">
            <a href="${item.url}" class="wf-cart-item__name">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="wf-cart-item__variant">${item.variant_title}</span>` : ''}
            <span class="wf-cart-item__price">${Cart.formatMoney(item.line_price)}</span>
            <div class="wf-cart-item__qty">
              <button class="wf-cart-item__qty-btn wf-qty-minus" data-line="${index + 1}" aria-label="Reducir cantidad">−</button>
              <span class="wf-cart-item__qty-val">${item.quantity}</span>
              <button class="wf-cart-item__qty-btn wf-qty-plus" data-line="${index + 1}" aria-label="Aumentar cantidad">+</button>
              <button class="wf-cart-item__remove" data-line="${index + 1}" aria-label="Eliminar">Eliminar</button>
            </div>
          </div>
        </div>`).join('');

      itemsContainer.innerHTML = itemsHTML;

      if (subtotalEl) subtotalEl.textContent = Cart.formatMoney(cart.total_price);

      Cart.bindItemEvents();
    },

    bindItemEvents() {
      if (!itemsContainer) return;

      itemsContainer.querySelectorAll('.wf-qty-minus').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const line = parseInt(btn.dataset.line, 10);
          const qtyEl = btn.nextElementSibling;
          const qty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
          const cart = await Cart.change(line, qty);
          Cart.render(cart);
          Cart.updateCount(cart.item_count);
        });
      });

      itemsContainer.querySelectorAll('.wf-qty-plus').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const line = parseInt(btn.dataset.line, 10);
          const qtyEl = btn.previousElementSibling;
          const qty = parseInt(qtyEl.textContent, 10) + 1;
          const cart = await Cart.change(line, qty);
          Cart.render(cart);
          Cart.updateCount(cart.item_count);
        });
      });

      itemsContainer.querySelectorAll('.wf-cart-item__remove').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const line = parseInt(btn.dataset.line, 10);
          const cart = await Cart.change(line, 0);
          Cart.render(cart);
          Cart.updateCount(cart.item_count);
        });
      });
    },
  };

  // Expose globally for quick view integration
  window.wfCart = Cart;
  window.wfCartDrawer = { open: Cart.open, close: Cart.close };

  // Initialize
  function init() {
    // Close drawer on overlay click
    if (overlay) {
      overlay.addEventListener('click', Cart.close);
    }

    // Close button
    document.querySelector('.wf-cart-drawer__close')?.addEventListener('click', Cart.close);

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') Cart.close();
    });

    // Cart icon in header opens drawer
    document.querySelectorAll('.wf-header__cart').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        await Cart.refresh();
        Cart.open();
      });
    });

    // Add to cart forms (product page + quick view)
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('.wf-product__atc');
      if (btn) btn.classList.add('wf-loading');

      try {
        const data = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: data });
        if (res.ok) {
          await Cart.refresh();
          Cart.open();
          // Close quick view if open
          const qv = document.getElementById('wf-quick-view');
          if (qv?.classList.contains('wf-active')) {
            qv.classList.remove('wf-active');
            qv.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        }
      } catch (err) {
        console.error('Error al añadir al carrito:', err);
      } finally {
        if (btn) btn.classList.remove('wf-loading');
      }
    });

    // Bundle add to cart
    document.querySelector('.wf-bundle__add-all')?.addEventListener('click', async function () {
      const ids = JSON.parse(this.dataset.ids || '[]');
      this.disabled = true;
      try {
        for (const id of ids) {
          await Cart.add(id);
        }
        await Cart.refresh();
        Cart.open();
      } finally {
        this.disabled = false;
      }
    });

    // Upsell add button in drawer
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('.wf-cart-drawer__upsell-add');
      if (!btn) return;
      const id = btn.dataset.variantId;
      if (!id) return;
      btn.disabled = true;
      try {
        await Cart.add(id);
        await Cart.refresh();
      } finally {
        btn.disabled = false;
      }
    });

    // Initial count
    Cart.get().then((cart) => Cart.updateCount(cart.item_count)).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
